// Module
var code = `<div id="mainWindow"></div>
<!--Context menu/Combobox dropdown-->
<div id="newContextMenu" class="new-context-menu-container"></div>
<!--Lookup search dropdown-->
<div id="newLookupSearchMenu" class="auto-complete-table-container"></div>
<div id="contextMenuContainer"></div>
<div id="datePickerDropDownContainer"></div>
<div id="autoCompleteTablesContainer"></div>
<div id="popover-container"></div>
<div id="tooltipContainer">
    <div class="ractive-tooltip ractive-tooltip-upper" style="display: none;"></div>
</div>
<div id="popupErrorScreenContainer"></div>
<div id="multiComboBoxContainer"></div>
<div id="buttonsPopupContainer"></div>`;
// Exports
export default code;